export default __webpack_public_path__ + "static/media/9_1.fb8de65f.jpg";